/* ===========================================================================
   Moving
   =========================================================================== */

import {
  movingItemSummaryList,
  movingItemName,
  movingItemSeeAllPairs,
  movingItemPayment,
  movingManufacturedItemSizeSelector
} from './item';

const movingHomeTitle = () => {
  const $title = document.getElementById('js-home-title');
  const $target = document.getElementById('js-home-title-moving');

  if ($title) {
    $($title)
      .insertBefore($($target))
      .removeClass('is-hidden');
  }
};

/*
   Window load
   ===================================== */

$(window).load(function() {

  movingHomeTitle();

  if ($('#js-item-name').length) {
    movingItemName();
  }

  if ($('#js-item-aside').length) {
    movingItemPayment();
    movingManufacturedItemSizeSelector();
  }

  if ($('#js-all-pairs').length) {
    movingItemSeeAllPairs();
  }

});



/*
   Windows resize
   ===================================== */

$(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {

  if ($('#js-item-name').length) {
    movingItemName();
  }

  if ($('#js-item-aside').length) {
    movingManufacturedItemSizeSelector();
  }

  if ($('#js-all-pairs').length) {
    movingItemSeeAllPairs();
  }

});
